import { render, staticRenderFns } from "./BtnInserirAporteParceiro.vue?vue&type=template&id=b88ddc8e"
import script from "./BtnInserirAporteParceiro.vue?vue&type=script&lang=js"
export * from "./BtnInserirAporteParceiro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports